import type { WalletView } from "@/services/clientWallets";

export interface WalletEntry {
    wallet: WalletView | null;
    label: string;
}

function entryFromWallet(wallet: WalletView): WalletEntry {
    return { wallet, label: wallet.label ?? "" };
}

export function replaceWalletEntry(entries: WalletEntry[], slotIdx: number, wallet: WalletView): WalletEntry[] {
    if (!entries[slotIdx]) return entries;
    return entries.map((entry, idx) => (idx === slotIdx ? entryFromWallet(wallet) : entry));
}

export function reconcileWalletEntries(localEntries: WalletEntry[], serverWallets: WalletView[]): WalletEntry[] {
    if (localEntries.length === 0) {
        return serverWallets.map(entryFromWallet);
    }

    const serverByUuid = new Map(serverWallets.map((wallet) => [wallet.uuid, wallet]));
    const localUuids = new Set<string>();
    const reconciled = localEntries.map((entry) => {
        if (!entry.wallet) return entry;
        localUuids.add(entry.wallet.uuid);
        const serverWallet = serverByUuid.get(entry.wallet.uuid);
        return serverWallet ? entryFromWallet(serverWallet) : entry;
    });

    for (const wallet of serverWallets) {
        if (!localUuids.has(wallet.uuid)) {
            reconciled.push(entryFromWallet(wallet));
        }
    }
    return reconciled;
}
